import React from 'react';

// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import {
  AccordionPanel as ChakraAccordionPanel,
  forwardRef,
} from '@chakra-ui/react';

import { AccordionPanelProps } from '../accordion-panel';

const AccordionPanel = forwardRef<AccordionPanelProps, 'div'>(
  ({ children, ...props }, ref) => {
    return (
      <ChakraAccordionPanel ref={ref} position="relative" {...props}>
        {children}
      </ChakraAccordionPanel>
    );
  }
);

export { AccordionPanel };
